import { render, staticRenderFns } from "./EditLabelDereference.vue?vue&type=template&id=38234d21&"
import script from "./EditLabelDereference.vue?vue&type=script&lang=js&"
export * from "./EditLabelDereference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports